import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full">
      <ol className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
        <li>
          <Link
            to="/"
            className="cursor-pointer transition-colors hover:text-primary-700"
          >
            首页
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={`${item.label}-${index}`} className="flex items-center gap-2">
            <i className="ri-arrow-right-s-line text-base text-foreground-400" />
            {item.to ? (
              <Link
                to={item.to}
                className="cursor-pointer transition-colors hover:text-primary-700"
              >
                {item.label}
              </Link>
            ) : (
              <span className="font-medium text-foreground-800" aria-current="page">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}